<template>
  <v-app id="app">
    <div class="fill-height">
      <div
        v-if="widget.loading && !$route.params.token && !$route.params.categoryCode"
        class="d-flex align-center justify-center fill-height"
      >
        <Loading :message="$t('starting')" />
      </div>
      <div v-else-if="$route.params.token || $route.params.categoryCode || (widget.data.uuid && storage.completed)">
        <div>
          <transition>
            <router-view />
          </transition>
          <Notification />
          <CammerAvailable v-if="$organization.detectCammerAvailability()" />
        </div>
      </div>
      <div
        v-else-if="widget.error && widget.error.statusCode === 11"
        class="text-center"
      >
        <Maintenance />
      </div>
      <div v-else class="text-center">
        <Info />
      </div>
    </div>
  </v-app>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Info: () => import(/* webpackPrefetch: true */ '@/components/Ocular.vue'),
    Loading: () => import(/* webpackPrefetch: true */ '@/components/Loading.vue'),
    Notification: () => import(/* webpackPrefetch: true */ '@/components/Notification.vue'),
    Maintenance: () => import(/* webpackPrefetch: true */ '@/components/Maintenance.vue'),
    CammerAvailable: () => import(/* webpackPrefetch: true */ '@/components/CammerAvailable.vue')
  },
  computed: {
    widget () {
      return this.$store.state.widget
    },
    storage () {
      return this.$store.state.services.storage
    }
  }
})
export default class App extends Vue {
  mounted () {
    this.$organization.getWidget()
  }
}
</script>

<style>
  @import './assets/css/main.css?v=1.1.1';
</style>